module.exports = __webpack_public_path__ + "img/title_txt_day4.a698fe22.png";